/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  index.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:27
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import app from "./modules/app";
import user from "./modules/user";
import permission from "./modules/permission";
import shoppingMall from "@/store/modules/shoppingMall";
import order from "@/store/modules/order";
import share from "@/store/modules/share";
import guarantee from "./modules/guarantee";
import getters from "./getters";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ["app", "user.token", "user.mobile",
        "user.userId", "user.password", "user.info", "user.companyId"
        , "user.companyName", "user.isCusMerchantLoan", "user.haveAuditPermission","user.whiteStrips"],
      storage: {
        getItem: (key) => localStorage.getItem(key),
        setItem: (key, value) => localStorage.setItem(key, value),
        removeItem: (key) => localStorage.removeItem(key),
      },
    }),
    createPersistedState({
      key: "vuex-index",
      paths: ["shoppingMall", "order", "share"],
      storage: {
        getItem: (key) => sessionStorage.getItem(key),
        setItem: (key, value) => sessionStorage.setItem(key, value),
        removeItem: (key) => sessionStorage.removeItem(key),
      },
    }),
  ],
  modules: {
    app,
    user,
    permission,
    shoppingMall,
    order,
    share,
    guarantee
  },
  state: {},
  mutations: {},
  actions: {},
  getters,
});
